import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "flex mt-4 info-connect" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('login-page.set-new-password')), 1)
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitChangePassword && _ctx.submitChangePassword(...args)), ["prevent"])),
      novalidate: "",
      class: "w-full"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputBlock, {
          label: _ctx.$t('forms.new-password'),
          modelValue: _ctx.v$.changePasswordForm.password.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.changePasswordForm.password.$model) = $event)),
          vuelidate: _ctx.v$.changePasswordForm.password,
          type: "password"
        }, null, 8, ["label", "modelValue", "vuelidate"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputBlock, {
          label: _ctx.$t('forms.new-password-confirmation'),
          modelValue: _ctx.v$.changePasswordForm.confirmationPassword.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.changePasswordForm.confirmationPassword.$model) = $event)),
          vuelidate: _ctx.v$.changePasswordForm.confirmationPassword,
          type: "password"
        }, null, 8, ["label", "modelValue", "vuelidate"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_app_button, {
          class: "w-full",
          type: "sumbit",
          buttonType: "main",
          buttonSize: "m",
          buttonText: _ctx.$t('button-label.validate'),
          onKeyup: _withKeys(($event: any) => (''), ["enter"]),
          isDisabled: _ctx.isSubmitDisabled
        }, null, 8, ["buttonText", "onKeyup", "isDisabled"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withCtx(() => [
          _createVNode(_component_app_button, {
            buttonType: "secondary",
            buttonSize: "s",
            buttonText: _ctx.$t('button-label.back'),
            class: "w-full"
          }, null, 8, ["buttonText"])
        ]),
        _: 1
      })
    ])
  ], 64))
}